import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {StatusInfo} from '@catfeatures/types';
import {Restangular} from 'ngx-restangular';

@Injectable()
export class ServicesService extends RestHttpService<StatusInfo> {

  constructor(service: Restangular) {
    super('services', service);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/services/services/services.service.ts